import { toTime } from '../../../../../utils/generalHelpers';
import styles from './style.module.scss';
import Webcam from 'react-webcam';
import { RefObject } from 'react';

interface Props {
    /** Seconds recorded so far on the current question. */
    elapsed: number;
    webcamRef: RefObject<Webcam>;
};

/** The proctoring panel: live camera preview with how long the answer has been running. */
function InterviewStream(props: Props) {
    const { elapsed, webcamRef } = props;
    const { minutes, seconds } = toTime(elapsed);

    return (
        <div className={styles.stream_box}>
            <div className={styles.stream_box_cam}>
                <Webcam
                    audio
                    muted
                    ref={webcamRef}
                    disablePictureInPicture
                />
            </div>
            <div className={styles.stream_box_extra}>
                <div className={styles.stream_box_extra_counter}>
                    <span className={styles.stream_box_extra_counter_live}></span>
                    <span className={styles.stream_box_extra_counter_stopwatch}>
                        {`${`${minutes}`.padStart(2, '0')}:${seconds}`}
                    </span>
                </div>
            </div>
        </div>
    )
};

export default InterviewStream;
